export const regalchromaggia69ModsTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
        if (desyncdata.indexOf('Failure: \'Regalchromaggia69') !== -1) {
          return {
            type: 'regalchromaggia69ModsTest',
            color: 'IndianRed',
            title: 'Outdated mods by Regalchromaggia69',
            text: 'You\'re using an outdated mod made by Regalchromaggia69.',
            description: 'Remove all files related to the <strong>Regalchromaggia69</strong> creator and check if there is a recent update available.'
            }
        }
    }
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>9886420370c3b5fa5b692777</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2018-08-07 02:06:59</createtime>
        <buildsignature>Local.Unknown.Unknown.1.45.62.1020-1.200.000.360.Release</buildsignature>
        <categoryid>utils.py:116</categoryid>
        <desyncid>9886420370c3b5fa5b692777</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Failure: 'Regalchromaggia69_Careers_SpaClerk.cpython-33' (Regalchromaggia69_Careers_SpaClerk.cpython-33) (ImportError: No module named 'Regalchromaggia69_Careers_SpaClerk.cpython-33'; Regalchromaggia69_Careers_SpaClerk is not a package)
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\importer\utils.py&quot;, line 119, in import_modules_by_path
  File &quot;&lt;frozen importlib._bootstrap&gt;&quot;, line 1520, in _find_and_load_unlocked
AttributeError: 'module' object has no attribute '__path__'

During handling of the above exception, another exception occurred:

Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\importer\utils.py&quot;, line 116, in import_modules_by_path
ImportError: No module named 'Regalchromaggia69_Careers_SpaClerk.cpython-33'; Regalchromaggia69_Careers_SpaClerk is not a package
</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/authors/regalchromaggia69ModsTest.js